// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "b7c2c0f";
